import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PortalDropdown from './portalDropdown';

@inject('rolesStore', 'translationsStore') @observer
export default class RolesDropdownContainer extends Component {
  
  translations = this.props.translationsStore;
  t = this.translations.translate;

  componentDidMount() {

    this.props.rolesStore.getAllRoles();
  }

  render() {

    if (this.props.rolesStore.roles == undefined) {
      
      return null;
    }

    let list = [];

    if (this.props.insertDefaultValue == true) {

      list.push({
        id: -1,
        name: this.props.translationsStore.translate('SELECT_ROLE')
      });
  
      this.props.rolesStore.roles.forEach(role => {
        
          list.push(role);
      });
    }
    else {

      list = this.props.rolesStore.roles;
    }
    
    return (
        <PortalDropdown
            {...this.props}
            hintText={this.props.hintText}
            floatingLabelText={this.props.floatingLabelText}
            width={this.props.width}
            disabled={this.props.disabled}
            onChange={this.props.onChange}
            errorText={this.props.errorText}
            value={this.props.value}
            helpTooltipText={this.props.helpTooltipText}
            items={list}
        />
    );
  }
}